<template>
    <div class="order-list-modal-helper">
        <div>
            <OrderDetailsModal
                v-if="showDetailsModal"
                :orderData="orderData"
                :open="showDetailsModal"
                :isMultipleOrders="isMultipleOrders"
                :initialTab="detailsInitialTab"
                :statusList="statusList"
                :peopleList="peopleList"
                :shiftList="shiftList"
                :showLinksProp="mode === 'links'"
                :showAttachmentsProp="mode === 'attachments'"
                @close="closeDetailsModal"
                @closeListModal="closeModal"
            >
                <template v-slot:back-button>
                    <div class="arrow-left-container">
                        <ArrowLeft />
                    </div>
                </template>
            </OrderDetailsModal>
        </div>

        <div class="order-list-modal-container animation-open-modal">
            <ModalHeader :close="closeModal" :title="modalTitle" />

            <ul class="list-content">
                <ItemList
                    v-for="({ operationId, operationLabel }, index) in orderList"
                    :key="`order-${index}`"
                    @select-item="selectItem(operationId)"
                >
                    <span>{{ operationLabel }}</span>
                </ItemList>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapMutations } from "vuex";
    import OrderDetailsModal from "@/views/pages/operator/components/OrderModal/OrderModal.vue";
    import ModalHeader from "./components/ModalHeader";
    import ItemList from "./components/ItemList";
    import ArrowLeft from "@/assets/images/new-icons/arrow-left-icon.svg";

    export default {
        name: "OrderDetailsListModal",
        components: {
            ModalHeader,
            ItemList,
            OrderDetailsModal,
            ArrowLeft
        },
        props: {
            orderList: {
                type: Array,
                default: () => [],
                required: true
            },
            isMultipleOrders: {
                type: Boolean,
                default: true
            },
            mode: {
                type: String,
                default: "details"
            },
            statusList: {
                type: Array,
                default: () => []
            },
            peopleList: {
                type: Array,
                default: () => []
            },
            shiftList: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                orderData: {},
                showDetailsModal: false,
                currentSite: this.$cookies.get("userInfo")?.currentSite
            };
        },
        computed: {
            modalTitle() {
                return this.mode === "history"
                    ? "ProductionProgress.OrdersHistory"
                    : "ProductionProgress.OrderDetails2";
            },
            detailsInitialTab() {
                if (this.mode === "history") return "history";
                if (this.mode === "links") return "links";
                if (this.mode === "attachments") return "attachments";
                return "info";
            }
        },
        mounted() {
            this.addOpenAnimation();
            this.UPDATE_FLAG_SHOW_OVERLAY(false);
        },
        methods: {
            ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
            ...mapActions("app", ["removeRequestLoading"]),
            async selectItem(id) {
                const order = await this.fetchOrder(id);
                this.orderData = { ...order };
                this.showDetailsModal = true;
            },
            closeDetailsModal() {
                this.showDetailsModal = false;
            },
            addOpenAnimation() {
                const modal = document.querySelector(".order-list-modal-container");
                if (!modal) return;
                modal.classList.add("animation-open-modal");

                setTimeout(
                    () => {
                        const el = document.querySelector(".order-list-modal-container");
                        if (el) el.classList.remove("animation-open-modal");
                    },
                    1000
                );
            },
            closeModal() {
                this.closeDetailsModal();
                this.closeAnimation();
            },
            closeAnimation() {
                const modal = document.querySelector(".order-list-modal-container");
                if (!modal) return;
                modal.classList.add("animation-close-modal");
                modal.classList.add("closed-modal");

                setTimeout(() => this.$emit("close", false), 500);
            },
            async fetchOrder(id) {
                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                const is_rework = this.$router.currentRoute.params.appointment_type;
                const GET_ORDER_URL = `/api/mysfc/operator/operation/${id}?isRework=${is_rework}&siteId=${this.currentSite}`;

                try {
                    const response = await this.$http2.get(GET_ORDER_URL);
                    return Promise.resolve(response.data.data);
                } catch (error) {
                    console.error(error);
                    return Promise.reject(error);
                } finally {
                    this.removeRequestLoading();
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .order-list-modal-helper {
        position: relative;
    }

    .arrow-left-container {
        padding: 5px;
        margin-right: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .order-list-modal-container {
        height: 100vh;
        width: 100vw;
        background: #fcfcfc;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;
        display: flex;
        flex-direction: column;

        &.closed-modal {
            top: 100vh;
        }

        &.animation-open-modal {
            animation: openModal 0.5s normal;

            @keyframes openModal {
                0% {
                    top: 100vh;
                }

                100% {
                    top: 0;
                }
            }
        }

        &.animation-close-modal {
            animation: closeModal 0.5s normal;

            @keyframes closeModal {
                0% {
                    top: 0;
                }

                100% {
                    top: 100vh;
                }
            }
        }

        .list-content {
            display: flex;
            flex-direction: column;
            gap: 16px;
            padding: 24px 29px;

            &::-webkit-scrollbar {
                width: 16px;
                /* width of the entire scrollbar */
            }

            &::-webkit-scrollbar-track {
                background: #fff;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #cfc4be;
                /* color of the scroll thumb */
                border-radius: 20px;
                /* roundness of the scroll thumb */
                border: 4px solid #fff;
                height: 70px;
            }

            overflow: auto;
            margin: 0;
        }
    }
</style>
